import { Line } from './line'
import { Pie } from './pie'
import { Bar } from './bar'

const ECHARTS_CONFIG_CLASSES_MAP = new Map([
  [Line.echartsType, Line],
  [Pie.echartsType, Pie],
  [Bar.echartsType, Bar],
])

export class CreateEchartsConfig {
  /**
   * 创建echarts配置
   * @param {String} echartsType - echarts类型
   * @param {Object} options - 参数
   */
  constructor(echartsType, options) {
    const EchartsConfigClass = ECHARTS_CONFIG_CLASSES_MAP.get(echartsType)
    if (!EchartsConfigClass) return {}
    return new EchartsConfigClass({
      ...options,
      echartsType
    })
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/common/basic/index.js